module.exports = __webpack_public_path__ + "img/ml3104.030d43c1.png";